import { render, staticRenderFns } from "./Deliver.vue?vue&type=template&id=748a981e&xmlns%3Ath=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml"
import script from "./Deliver.vue?vue&type=script&lang=js"
export * from "./Deliver.vue?vue&type=script&lang=js"
import style0 from "./Deliver.vue?vue&type=style&index=0&id=748a981e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports